<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2025-11-26 16:11:21
 * @Description:
 * @LastEditors: Please set LastEditors
-->
<template>
  <div v-if="lableList.length !== 0 || devicePanelControlEnabled" class="top-120px lable_list rounded-4px">
    <div
      v-if="showLablePanel"
      class="p-10px"
      :class="lableList.length > 5 ? 'w-186px' : 'max-w-120px'"
    >
      <el-row :gutter="20">
        <el-col :span="lableList.length > 5 ? 12 : 24" :offset="0" class="pb-10px">
          <div
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-checkbox
              :disabled="checkboxDisable"
              class="text-[#cbeaff]"
              v-model="allChecked"
              @change="handlerCheckboxChange('all')"
              >全部</el-checkbox
            >
          </div>
        </el-col>
        <el-col
          v-for="item in lableList"
          :key="item.id"
          :span="lableList.length > 5 ? 12 : 24"
          :offset="0"
          class="pb-10px"
        >
          <div
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-checkbox
              :disabled="item.disabled"
              class="text-[#cbeaff]"
              v-model="item.checked"
              @change="handlerCheckboxChange(item)"
              >{{ item.name }}</el-checkbox
            >
          </div>
        </el-col>
        <el-col v-if="devicePanelControlEnabled">
          <el-checkbox v-model="devicePanelChecked">设备面板</el-checkbox>
        </el-col>
      </el-row>
    </div>
    <div class="absolute top-0px right-[-28px]">
      <img
        v-if="!showLablePanel"
        @click="showLablePanel = !showLablePanel"
        class="w-24px h-24px cursor-pointer"
        src="../../assets/images/expand.png"
      />
      <img
        v-if="showLablePanel"
        @click="showLablePanel = !showLablePanel"
        class="w-24px h-24px cursor-pointer"
        src="../../assets/images/collapse.png"
      />
    </div>
  </div>
</template>

<script>
import { forEach, filter, eq } from 'lodash'
import DeviceList from '../../assets/js/componentMethods/deviceList'
import RiskAreaHZ from '../../assets/js/componentMethods/riskArea'
import BuildingList from '../../assets/js/componentMethods/buildingList'
import RiskAssignment from '../../assets/js/componentMethods/riskAssignment'
import PersonnelList from '../../assets/js/componentMethods/personnelList'
import ElectronicFence from '../../assets/js/componentMethods/electronicFence'
import BridgeCable from '../../assets/js/componentMethods/bridgeCable'
import CarList from '../../assets/js/componentMethods/carList'
import SafetyIsland from '../../assets/js/componentMethods/safetyIsland'
import EscapeRoute from '../../assets/js/componentMethods/escapeRoute'
import PlantPerson from '../../assets/js/componentMethods/PlantPerson'
import EmergencySupplies from '../../assets/js/componentMethods/emergencySupplies'
import VideoList from '../../assets/js/componentMethods/videoList'
import TaskInfo from '../../assets/js/componentMethods/taskInfo'
import SafetyQuality from '../../assets/js/componentMethods/safetyQuality'
import DeviceMarker from '../../assets/js/componentMethods/deviceMarker'
import EmergencyMonitor from '../../assets/js/componentMethods/EmergencyCamera'

const CameraList = new DeviceList({ name: '摄像头', value: 'camera' })
const AccessList = new DeviceList({ name: '门禁', value: 'access' })
const BarrierList = new DeviceList({ name: '道闸', value: 'barrier' })

export default {
  name: 'VisualizationFunctionList',
  props: {
    // 标签默认显示列表
    lableDtos: {
      type: Array,
      default: () => {
        return []
      },
    },
    defaultLableDtos: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 需要打开的组件
    openLableList: {
      type: Array,
      default: () => {
        return []
      },
    },
    player: {
      type: Object,
      default: null,
    },
    noticeCloseComponent: {
      type: Object,
      default: () => {
        return {}
      },
    },
    sourceId: {
      type: String,
      defalut: '',
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    collapseLabels: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showLablePanel: true,
      lableList: [],
      startLableOrigin: {},
      // 楼层中的电子围栏筛选
      filterElectronicIdList: null,
      isInfloor: false,
      checkboxDisable: false,
      areaId: '',
      defaultSettings: {},
      // 关闭按需渲染的标签
      notAutoUpdateFrameLabelList: ['PersonnelList', 'RiskAreaHZ'],
      devicePanelChecked: true, // 是否展示全局设备面板s
    }
  },
  computed: {
    allChecked: {
      get() {
        return _.every(this.lableList, ['checked', true]) && this.devicePanelChecked
      },
      set() {},
    },
    computedLabelList() {
      return JSON.parse(JSON.stringify(this.lableList))
    },
    // 设备面板开关配置
    devicePanelControlEnabled() {
      const devicePanelConfig = Wiz.globalSettings.globalConfig?.visualizationConfig?.devicePanel || {}
      return devicePanelConfig.devicePanelControlEnabled
    }
  },
  watch: {
    collapseLabels(val) {
      if (val) {
        this.showLablePanel = !val
      }
    },
    async lableDtos() {
      // 关闭之前的功能
      await this.closeAllLable()
      this.lableList = _.clone(this.lableDtos)
      this.activeLableList()
    },
    openLableList() {
      // 筛选出当前需要加载标签
      const currentData = _.filter(this.openLableList, (item) => {
        const currentLableIndex = _.findIndex(this.lableList, ['code', item.code])
        const status = !this.lableList[currentLableIndex].checked
        this.lableList[currentLableIndex].checked = true
        return status
      })
      // 记录标签开启的来源
      _.forEach(this.openLableList, (item) => {
        if (!currentData.includes(item) && this.startLableOrigin[item.code]) {
          if (!this.startLableOrigin[item.code].includes(item.origin)) {
            this.startLableOrigin[item.code].push(item.origin)
          }
        } else if (currentData.includes(item)) {
          this.startLableOrigin[item.code] = [item.origin]
        }
      })
      this.openLable(currentData)
    },
    noticeCloseComponent: {
      handler(val) {
        if (_.isEmpty(val)) return
        _.forEach(this.lableList, (el) => {
          const currentIndex = _.findIndex(this.startLableOrigin[el.code] || [], (item) => {
            return item === val.code
          })
          if (currentIndex !== -1) {
            this.startLableOrigin[el.code].splice(currentIndex, 1)
          }
          if (currentIndex !== -1 && el.checked && _.isEmpty(this.startLableOrigin[el.code])) {
            this.chooseLable(el, 'destroy')
            el.checked = false
          }
        })
      },
      deep: true,
    },
    computedLabelList: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$emit('updateLabel', newValue, oldValue, this.isInfloor)
        this.isInfloor = false
      },
    },
    areaId(id) {
      // id改变  重新获取新数据  其余隐藏(仅路线，物资，人员区分区域)
      const selectedComs = filter(this.lableList, (label) => {
        return label.checked
      })
      forEach(selectedComs, (com) => {
        switch (com.code) {
          case 'EscapeRoute':
            EscapeRoute.update(this.player, this.sourceId, this.cloudRender, id)
            break
          case 'EmergencySupplies':
            EmergencySupplies.update(this.player, this.sourceId, this.cloudRender, id)
            break
          case 'PlantPerson':
            // PlantPerson.update(this.player, id)
            break
          case 'EmergencyMonitor':
            EmergencyMonitor.update(this.player, this.cloudRender, this.sourceId, id)
            break
          default:
            break
        }
      })
    },
    lableList: {
      deep: true,
      handler(val) {
        const checkedCode = _.map(
          _.filter(val, (item) => {
            return item.checked
          }),
          'code'
        )
        const difference = _.difference(checkedCode, this.notAutoUpdateFrameLabelList)
        if (difference.length !== checkedCode.length) {
          this.player.Native?.Setting.set('sys.autoUpdateFrame', 'bool', false)
        }
      },
    },
    // 监听是否勾选设备面板
    devicePanelChecked(val) {
      if (val) {
        this.setDisabledPanel(true)
      } else {
        this.setDisabledPanel(false)
      }
    }
  },
  async created() {
    this.lableList = _.clone(this.lableDtos)
    this.defaultSettings = await this.player.Native.Setting.getAll()
    this.$emit('updateLabel', this.lableList, [])
    this.activeLableList()
  },
  mounted() {
    window.addEventListener('setComponentVisible', this.componentVisibleHandler)
    window.addEventListener('filterElectronicList', this.filterElectronicHandler)
    window.addEventListener('setCheckDisable', this.setCheckDisable)
    window.addEventListener('setLabelChecked', this.setLabelChecked)
    window.addEventListener('sendAreaId', this.receiveAreaId)
    window.addEventListener('updateCamera', this.updateCameraHandler)
  },
  methods: {
    // 设置面板是否展示
    async setDisabledPanel(status) {
      const openEvent = new CustomEvent('setDisabledPanel', {
        detail: {
          panelSwitchConfig: true, // 面板开关配置
          status,
        },
      })
      window.dispatchEvent(openEvent)
    },
    receiveAreaId(e) {
      this.areaId = e.detail.areaId
    },
    // 设置标签是否可以选择
    setCheckDisable(e) {
      if (!_.isNil(e.detail.disable)) {
        this.$nextTick(() => {
          // 如果没有传递tagList，那么默认全部设置
          if (_.isEmpty(e.detail.tagList)) {
            this.checkboxDisable = e.detail?.disable
            this.lableList = _.map(this.lableList, (item) => {
              return {
                ...item,
                disabled: e.detail.disable,
              }
            })
          } else {
            // 如果传递了tagList，则设置部分
            this.lableList = _.map(this.lableList, (item) => {
              if (_.includes(e.detail.tagList, item.code)) {
                return {
                  ...item,
                  disabled: e.detail.disable,
                }
              }
              return item
            })
          }
        })
      }
    },
    componentVisibleHandler(e) {
      // 隐藏
      if (e?.detail?.type === 'hidden') {
        this.isInfloor = true
        this.lableList = e.detail.newLabelList
        _.forEach(e.detail.hiddenList, (item) => {
          this.chooseLable(item, 'hidden')
        })
        // 展示
      } else if (e?.detail?.type === 'display') {
        this.lableList = e.detail.newLabelList
        this.filterElectronicIdList = null
        _.forEach(e.detail.displayLabelList, (item) => {
          this.chooseLable(item, 'display')
        })
      }
    },
    filterElectronicHandler(e) {
      if (!_.isNil(e.detail.filterElectronicIdList)) {
        this.filterElectronicIdList = e.detail.filterElectronicIdList
      }
    },
    activeLableList() {
      this.lableList = _.map(this.lableList, (item) => {
        const checked = !!_.find(this.defaultLableDtos, ['code', item.code])
        if (checked) {
          this.chooseLable(item, 'create')
        }
        return {
          ...item,
          checked: !!_.find(this.defaultLableDtos, ['code', item.code]),
        }
      })
    },
    openLable(lableList) {
      _.forEach(lableList, (lable) => {
        this.chooseLable(lable, 'create')
      })
    },
    /**
     * @description: 选择lable,激活或关闭功能
     * @param {*} item
     * @param {*} status
     * @return {*}
     */

    async chooseLable(item, type) {
      switch (item.code) {
        case 'TaskInfo':
          await TaskInfo[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'VideoList':
          await VideoList[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'CameraList':
          await CameraList[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'SafetyQuality':
          await SafetyQuality[type](this.player, this.sourceId)
          break
        case 'BarrierList':
          await BarrierList[type](this.player, this.sourceId)
          break
        case 'AccessList':
          await AccessList[type](this.player, this.sourceId)
          break
        case 'RiskAreaHZ':
          await RiskAreaHZ[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'BuildingList':
          await BuildingList[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'RiskAssignment':
          await RiskAssignment[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'PersonnelList':
          // 关闭人员定位功能，历史轨迹组件关闭
          if (type === 'destroy') this.$emit('closeTrajectory')
          await PersonnelList[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'ElectronicFence':
          await ElectronicFence[type](
            this.player,
            this.sourceId,
            this.cloudRender,
            this.filterElectronicIdList
          )
          if (type === 'destroy') {
            this.filterElectronicIdList = null
          }
          break
        case 'BridgeCable':
          BridgeCable[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'CarList':
          CarList[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'SafetyIsland':
          SafetyIsland[type](this.player, this.sourceId, this.cloudRender)
          break
        case 'EscapeRoute':
          EscapeRoute[type](this.player, this.sourceId, this.cloudRender, this.areaId)
          break
        case 'EmergencyMonitor':
          EmergencyMonitor[type](this.player, this.cloudRender, this.sourceId, this.areaId)
          break
        case 'PlantPerson':
          PlantPerson[type](this.player, this.sourceId, this.cloudRender)

          break
        case 'EmergencySupplies':
          EmergencySupplies[type](this.player, this.sourceId, this.cloudRender, this.areaId)
          break
        case 'DeviceMarker':
          DeviceMarker[type](this.player, this.sourceId, this.cloudRender)
          break
        default:
          break
      }
    },
    // checkbox点击事件处理
    handlerCheckboxChange(item) {
      if (item === 'all') {
        if (this.allChecked) {
          _.forEach(this.lableList, (lable) => {
            this.chooseLable(lable, 'destroy')
          })
          this.lableList = _.map(this.lableList, (label) => {
            return {
              ...label,
              checked: false,
            }
          })
          this.devicePanelChecked = false
          return
        }
        // 计算需要开启的功能
        this.openLable(
          _.filter(this.lableList, (label) => {
            return !label.checked
          })
        )
        // 将所有选择状态修改成已勾选
        this.lableList = _.map(this.lableList, (label) => {
          return {
            ...label,
            checked: true,
          }
        })
        this.startLableOrigin = {}
        this.devicePanelChecked = true
        return
      }
      _.forEach(_.keys(this.startLableOrigin), (el) => {
        if (el === item.code) {
          delete this.startLableOrigin[el]
        }
      })
      this.chooseLable(item, item.checked ? 'create' : 'destroy')
    },
    // 关闭所有lable
    async closeAllLable(omitTarget = '') {
      for (let i = 0; i < this.lableList.length; i++) {
        const element = this.lableList[i]
        if (element.checked) {
          if (eq(element.code, omitTarget)) {
            continue
          }
          await this.chooseLable(element, 'destroy')
          delete this.startLableOrigin[element.code]
          this.lableList[i].checked = false
        }
      }
    },
    async setLabelChecked(e) {
      if (e.detail?.isCloseAllOmitOne) {
        await this.closeAllLable(e.detail.code)
      }
      const label = _.find(this.lableList, { code: e.detail.code })
      if (label) {
        if (label.checked !== e.detail.checked) {
          label.checked = e.detail.checked
          this.chooseLable(label, e.detail.checked ? 'create' : 'destroy')
        }
      }
    },
    // 更新摄像头标签的图片
    async updateCameraHandler(e) {
      if (!_.isEmpty(e.detail?.alarmList) && e.detail?.isAlarm) {
        CameraList.update(true, e.detail?.alarmList)
      } else {
        CameraList.update(false)
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('setComponentVisible', this.componentVisibleHandler)
    window.removeEventListener('filterElectronicList', this.filterElectronicHandler)
    window.removeEventListener('setCheckDisable', this.setCheckDisable)
    window.removeEventListener('setLabelChecked', this.setLabelChecked)
    window.removeEventListener('updateCamera', this.updateCameraHandler)
    // 如果打开了人员标签，断开websocket连接
    _.forEach(this.lableList, (label) => {
      if (label.checked) {
        this.chooseLable(label, 'destroy')
      }
    })
  },
}
</script>

<style lang="scss" scoped></style>
